module.exports = __webpack_public_path__ + "static/IntroducingLaunchDarklyforJira-a983f847ef42f8fb76a3d11aca48f0b6.png";